import { useState } from "react";
import { IconSend } from "@tabler/icons-react";
import ModalShell from "../../../../components/Support/ModalShell";
import Button from "../../../../components/UI/Button/button";
import Input, {
  Select,
  Textarea,
} from "../../../../components/UI/FormInput/input";

const EMPTY_FORM = { to: "", inbox: "User Inbox", subject: "", message: "" };

export default function NewMessageModal({ open, onClose, onSubmit, sending }) {
  const [form, setForm] = useState(EMPTY_FORM);

  const setField = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  function handleClose() {
    setForm(EMPTY_FORM);
    onClose();
  }

  async function handleSend() {
    const ok = await onSubmit?.(form);
    if (ok) setForm(EMPTY_FORM);
  }

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      color="blue"
      title="New Message"
      footer={
        <>
          <Button variant="outlineBlue" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            leftIcon={<IconSend size={15} />}
            onClick={handleSend}
            disabled={sending}
          >
            {sending ? "Sending…" : "Send"}
          </Button>
        </>
      }
    >
      <Input
        label="To (User / Email)"
        id="newMsgTo"
        placeholder="Search user or enter email…"
        value={form.to}
        onChange={setField("to")}
      />
      <Select
        label="Inbox"
        id="newMsgInbox"
        value={form.inbox}
        onChange={setField("inbox")}
      >
        <option>User Inbox</option>
        <option>Support Inbox</option>
      </Select>
      <Input
        label="Subject"
        id="newMsgSubject"
        placeholder="Message subject…"
        value={form.subject}
        onChange={setField("subject")}
      />
      <Textarea
        label="Message"
        id="newMsgBody"
        placeholder="Write your message…"
        rows={5}
        value={form.message}
        onChange={setField("message")}
      />
    </ModalShell>
  );
}
